import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SearchListIcon from 'components/SvgIcons/ComplexIcons/search-list.svg';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';

import './table.scss';

export class Table extends React.PureComponent {
  static propTypes = {
    sort: PropTypes.string,
    data: PropTypes.array,
    config: PropTypes.object.isRequired,
    className: PropTypes.string,
    total: PropTypes.number,
  };

  static defaultProps = {
    sort: null,
    data: [],
    className: '',
  };

  render() {
    const { data, config, sort, className, total, dataTestId } = this.props;

    return (
      <div
        className={classnames('table-container', className)}
        data-testid="table-container"
      >
        <table
          className="table"
          data-testid={dataTestId ? `${dataTestId}-table` : 'table'}
        >
          <TableHeader
            config={config}
            defaultSort={config.defaultSort}
            sort={sort}
          />

          <TableBody config={config} data={data} dataTestId={dataTestId} />
        </table>
        {typeof total === 'undefined' && <div className="table__search" />}
        {total === 0 && (
          <div className="table__search">
            <SearchListIcon height="5.5rem" width="5.5rem" />
            <div className="montserrat color-gray medium-bold mt-7">
              {config.noDataMessage || 'No results found for your request'}
            </div>
          </div>
        )}
      </div>
    );
  }
}
